import { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageHeader, EmptyState } from "../../components/app/Common";
import { fmtDate } from "../../lib/utils";
import { MessageSquare } from "lucide-react";

export default function AdminChatMonitor() {
  const [msgs, setMsgs] = useState([]);
  useEffect(() => {
    api.get("/chat/monitor/recent?limit=200").then(({ data }) => setMsgs(data));
  }, []);
  return (
    <div className="p-6 md:p-10 max-w-4xl mx-auto">
      <PageHeader title="Chat Monitor" subtitle="Latest messages across every jobsite. Admin read-only view." />
      {msgs.length === 0 ? (
        <EmptyState title="No messages" body="Once workers chat, you'll see everything here." />
      ) : (
        <div className="space-y-3" data-testid="monitor-list">
          {msgs.map((m) => (
            <div key={m.id} className="border border-border bg-card rounded-sm p-4 flex items-start gap-3">
              <div className="h-8 w-8 rounded-sm bg-muted grid place-items-center font-mono text-[10px] uppercase">{(m.user_name||"?").slice(0,2)}</div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium">{m.user_name}</span>
                  <span className="overline">{m.role}</span>
                  <span className="ml-auto text-[11px] font-mono text-muted-foreground">{fmtDate(m.created_at)}</span>
                </div>
                <div className="text-[11px] font-mono text-muted-foreground mt-0.5 inline-flex items-center gap-1">
                  <MessageSquare className="h-3 w-3" /> site {m.jobsite_id?.slice(0, 8)}…
                </div>
                <div className="mt-2 text-sm whitespace-pre-wrap">{m.text}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
